import React from "react";
import './HowToBuyHero.module.scss';

export const HowToBuyHero = () => (
    <div className="how-to-buy-hero-wrapper">
        <div className="how-to-buy-hero-container">
            <h1 className="title">
                Cara Beli Asuransi Online di Lifepal
            </h1>
            <p className="description">
                Beli asuransi di Lifepal bisa dilakukan dengan mudah secara online di mana dan kapan saja. Yuk, ikuti langkah-langkah mudah di bawah dan dapatkan proteksi asuransi dengan harga terbaik!
            </p>
        </div>
    </div>
);

export default HowToBuyHero;